import { render } from "./EditSliderHero.vue?vue&type=template&id=dbf7bc4c"
import script from "./EditSliderHero.vue?vue&type=script&lang=js"
export * from "./EditSliderHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__